export function validateImageFile(file, options = {}) {
  if (!(file instanceof File)) {
    return { ok: false, error: 'No file selected.' };
  }
  const {
    maxSizeMB = 10, // default 10 MB
    allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'],
    allowHeic = true
  } = options;

  const sizeLimit = maxSizeMB * 1024 * 1024;
  if (file.size && file.size > sizeLimit) {
    return { ok: false, error: `File is too large. Maximum size is ${maxSizeMB} MB.` };
  }

  const type = (file.type || '').toLowerCase();
  const isHeic = type === 'image/heic' || type === 'image/heif';
  if (allowHeic && isHeic) {
    // Some browsers/cameras produce HEIC/HEIF; we'll allow and rely on canvas conversion later
    return { ok: true };
  }

  if (allowedTypes.length && !allowedTypes.includes(type)) {
    return { ok: false, error: 'Invalid file type. Please select a JPEG, PNG, WebP, or GIF image.' };
  }

  return { ok: true };
}

export function makeObjectURL(file) {
  try {
    return URL.createObjectURL(file);
  } catch {
    return null;
  }
}

export function revokeObjectURL(url) {
  try { if (url) URL.revokeObjectURL(url); } catch {}
}
